import { useGraphQLQuery } from '@betterment/js-runtime';
import { Box, Card, Heading, Separator, Text } from '@betterment/samba-react';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { MatchDetailsDialog } from './components/MatchDetailsDialog';
import { EmployerMatchDetailsDocument } from './graphql/employerMatch.generated';

import StudentLoanMatchGuidanceBox from '../../../FourOhOneK/components/StudentLoanMatchGuidanceBox';

export const EmployerMatchDetails: React.FC = () => {
  const purposeId = useRequiredParam('purposeId');
  const { data } = useGraphQLQuery(EmployerMatchDetailsDocument, { variables: { id: purposeId }, throwOnError: true });

  if (!data) return <CardLoader />;

  const contributionConfig = data.purpose.envelope.payrollContributionConfigs
    .flatMap(c => c.employer.contributionConfig)
    .filter(c => !!c)[0];

  if (!contributionConfig) return null;

  const shouldShowDiscretionaryDescription =
    contributionConfig.isDiscretionary && contributionConfig.discretionaryWithTiersDescription;

  return (
    <Card css={{ padding: 'space.300', display: 'grid', gap: 'space.300' }}>
      <Card.Header>
        <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
          <Heading as="h3" css={{ textStyle: { base: 'title100', md: 'title200' } }}>
            Employer match
          </Heading>
          <MatchDetailsDialog {...contributionConfig} />
        </Box>
      </Card.Header>
      <Separator />
      <Card.Content>
        <Text as="p" css={{ mb: 'space.100' }}>
          {contributionConfig.ctaDescription}
        </Text>
        {shouldShowDiscretionaryDescription && (
          <Text as="p" css={{ mb: 'space.100' }}>
            {contributionConfig.discretionaryWithTiersDescription}
          </Text>
        )}
        <StudentLoanMatchGuidanceBox location="goal_overview_employer_match" />
      </Card.Content>
    </Card>
  );
};

export const EmployerMatchCard: React.FC = () => {
  return (
    <ErrorBoundary fallbackType="none">
      <EmployerMatchDetails />
    </ErrorBoundary>
  );
};
